import type { GroupedSmartSurveyorElement } from "components/SmartSurveyor/ReviewPage/types";
import type { CreateNewMarker, IsSameBbox, TranslateBbox } from "./types";

export const translateBbox: TranslateBbox = ({ bbox, newCenter }) => {
  const deltaX = newCenter.x - (bbox.x1 + bbox.x2) / 2;
  const deltaY = newCenter.y - (bbox.y1 + bbox.y2) / 2;

  return {
    x1: bbox.x1 + deltaX,
    y1: bbox.y1 + deltaY,
    x2: bbox.x2 + deltaX,
    y2: bbox.y2 + deltaY,
  };
};

export const createNewMarker: CreateNewMarker = ({
  markerId,
  bboxX1,
  bboxY1,
  bboxX2,
  bboxY2,
  multiplier,
  scaleFactor,
  pageIndex,
  floorPlanImage,
  elementTypeName,
  rgb,
}) => {
  const marker: GroupedSmartSurveyorElement = {
    id: markerId,
    name: "",
    layer: "",
    rgb,
    txt: "",
    group_id: elementTypeName,
    grid_cols: [],
    grid_rows: [],
    position_description: "",
    bbox: {
      x1: bboxX1 * scaleFactor,
      y1: bboxY1 * scaleFactor,
      x2: bboxX2 * scaleFactor,
      y2: bboxY2 * scaleFactor,
    },
    multiplier,
    page: pageIndex,
    status: "installed",
    floorPlanImage,
    _scaleFactor: scaleFactor,
    note: null,
  };

  return marker;
};

export const isSameBbox: IsSameBbox = ({ first, second }) =>
  first.x1 === second.x1 &&
  first.y1 === second.y1 &&
  first.x2 === second.x2 &&
  first.y2 === second.y2;
